var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7685 8.51355H11.2311C9.70874 8.51355 8.47021 9.75208 8.47021 11.2744V20.8119C8.47021 22.3342 9.70874 23.5731 11.2311 23.5731H20.7685C22.2908 23.5731 23.5297 22.3345 23.5297 20.8119V11.2744C23.5297 9.75208 22.2912 8.51355 20.7685 8.51355ZM15.9998 21.0008C13.2664 21.0008 11.0425 18.7769 11.0425 16.0431C11.0425 13.3097 13.2664 11.0858 15.9998 11.0858C18.7335 11.0858 20.9575 13.3097 20.9575 16.0431C20.9575 18.7765 18.7332 21.0008 15.9998 21.0008ZM21.1168 12.1108C20.4698 12.1108 19.9436 11.5846 19.9436 10.9378C19.9436 10.2911 20.4698 9.76491 21.1168 9.76491C21.7636 9.76491 22.2898 10.2911 22.2898 10.9378C22.2898 11.5846 21.7636 12.1108 21.1168 12.1108Z",
    fill: "#EF5285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.1807C14.4221 13.1807 13.1372 14.4648 13.1372 16.0428C13.1372 17.6214 14.4221 18.9059 16 18.9059C17.5787 18.9059 18.8625 17.6214 18.8625 16.0428C18.8625 14.4652 17.5783 13.1807 16 13.1807Z",
    fill: "#EF5285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.1638 0 0 7.1638 0 16C0 24.8362 7.1638 32 16 32C24.8362 32 32 24.8362 32 16C32 7.1638 24.8362 0 16 0ZM25.6245 20.8119C25.6245 23.4896 23.4465 25.6676 20.7687 25.6676H11.2313C8.55384 25.6676 6.37554 23.4896 6.37554 20.8119V11.2744C6.37554 8.59698 8.55384 6.41868 11.2313 6.41868H20.7687C23.4465 6.41868 25.6245 8.59698 25.6245 11.2744V20.8119Z",
    fill: "#EF5285"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9356230503d581d117c3a1aec8e86864.svg";
export { ForwardRef as ReactComponent };